import React from "react";
import ReactDom from "react-dom";
import AiOutlineCloseSquare from "@meronex/icons/ai/AiOutlineCloseSquare";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var Overlay = function Overlay(_ref) {
  var visible = _ref.visible,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("div", {
    onClick: onClick,
    className: "fixed z-30 inset-0 bg-gray-700 bg-opacity-60 overflow-y-auto h-full w-full" + (visible ? " block" : " hidden"),
    id: "my-modal"
  });
};
var Modal = function Modal(_ref2) {
  var className = _ref2.className,
    visible = _ref2.visible,
    onClick = _ref2.onClick,
    children = _ref2.children,
    showCloseButton = _ref2.showCloseButton;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/ReactDom.createPortal(/*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Overlay, {
      visible: visible,
      onClick: onClick
    }), visible && /*#__PURE__*/_jsxs("div", {
      className: " fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ".concat(className ? className : "w-4/5 md:w-3/5 lg:w-3/6 xl:w-2/5 2xl:w-1/3", "  mx-auto overflow-y-visible  z-40 \""),
      children: [showCloseButton && /*#__PURE__*/_jsx(AiOutlineCloseSquare, {
        onClick: onClick,
        className: "absolute h-8 w-8 right-0 top-0 z-10 text-black cursor-pointer"
      }), /*#__PURE__*/_jsx("div", {
        className: " ".concat(className ? "" : "py-4", " bg-white h-full shadow-sm rounded-md overflow-y-auto"),
        children: children
      })]
    })]
  }), document.getElementById("modal"));
};
export default Modal;